export default "__VITE_ASSET__t_44AEOM__"